import { boolean, object, ObjectSchema, string } from 'yup';

export type PayorEnrollmentForm = {
  npi?: string;
  caqhId: string;
  caqhUsername: string;
  caqhPassword: string;
  confirmProfile: boolean;
  authorizeAccess: boolean;
  confirmAccuracy: boolean;
};

export const payorEnrollmentValidation: ObjectSchema<PayorEnrollmentForm> = object({
  npi: string()
    .notRequired()
    .test('npi-format', 'NPI must be 10 digits', value => !value || /^\d{10}$/.test(value)),
  caqhId: string()
    .matches(/^\d{8}$/, 'CAQH number must be exactly 8 digits')
    .required('Enter your CAQH number'),
  caqhUsername: string()
    .required('Enter your CAQH username'),
  caqhPassword: string()
    .required('Enter your CAQH password'),
  confirmProfile: boolean()
    .oneOf([ true ]).required(),
  authorizeAccess: boolean()
    .oneOf([ true ]).required(),
  confirmAccuracy: boolean()
    .oneOf([ true ]).required(),
});

export const payorEnrollmentInitialValues: PayorEnrollmentForm = {
  npi: '',
  caqhId: '',
  caqhUsername: '',
  caqhPassword: '',
  confirmProfile: false,
  authorizeAccess: false,
  confirmAccuracy: false,
};
